module.exports = __webpack_public_path__ + "img/terImg5.5dfc74af.png";